(function () {
  'use strict';

  angular.module('app').component('packageContentDayDetail', packageContentDayDetail());

  function packageContentDayDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        packageContent: '=',
        onPackageContentDaySaved: '&',
        onPackageContentDayCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: PackageContentDayDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/package-contents/package-content-days/package-content-day-detail/package-content-day-detail.component.html',
    };
  }

  PackageContentDayDetailComponent.$inject = ['UtilService', 'PackageContentDayService'];

  function PackageContentDayDetailComponent(UtilService, PackageContentDayService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = [
      'name',
      'description',
      'url_video',
      'included',
      'excluded',
      'notes',
      'package_day_id',
    ];

    var cropedImage = { file: null };

    // Methods
    vm.editPackageContentDay = editPackageContentDay;
    vm.cancelEdit = cancelEdit;
    vm.savePackageContentDay = savePackageContentDay;
    vm.cancel = cancel;

    vm.openLogo = openLogo;

    vm.openPackageContentDayTranslations = openPackageContentDayTranslations;

    vm.onPackageContentDayPhotosSaved = onPackageContentDayPhotosSaved;

    vm.$onInit = function () {
      setItemOptions(vm.item, vm.mode);

      vm.packageDays = vm.packageContent.package.package_days;
    };

    function setItemOptions(item, mode = '') {
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editPackageContentDay();
      }

      if (item.url_video) {
        vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(item.url_video);
      }

      vm.labelAddLogo = item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';

      vm.originalItem = angular.copy(item); // store server data
    }

    function editPackageContentDay() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    // Create/Update
    function savePackageContentDay(isFormValid) {
      vm.formErrors = false;

      var scrollTo = 'content_day_detail';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop(scrollTo);

        return;
      }

      // console.log(vm.item);
      // return;

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        PackageContentDayService.savePackageContentDay(
          vm.item,
          vm.packageContent.id,
          vm.defaultLanguage,
          cropedImage
        ).then(
          function (response) {
            var data = response.data;

            if (!vm.editMode) {
              // create
              vm.item = data; // reload item
            }

            setItemOptions(data);

            vm.onPackageContentDaySaved({ item: data });

            vm.UtilService.scrollToTop(scrollTo);

            vm.sendingForm = false;
          },
          function (response) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);
            vm.formErrors = true;

            vm.UtilService.scrollToTop(scrollTo);

            vm.sendingForm = false;
          }
        );
      } else {
        cancel();
      }
    }

    function cancel() {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onPackageContentDayCanceled();
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          let updateLogoCallback = (data) => {
            vm.item.logo = data.logo;
            vm.item.logoUrl = vm.UtilService.cleanItemCache(data, 'logo');

            vm.originalItem.logo = angular.copy(vm.item.logo);
            vm.originalItem.logoUrl = angular.copy(vm.item.logoUrl);

            vm.item.logoUpdated = true;

            vm.onPackageContentDaySaved({ item: vm.item });
          };

          PackageContentDayService.updateLogo(
            vm.item,
            vm.packageContent.id,
            cropedImage,
            updateLogoCallback
          );
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      PackageContentDayService.openLogo(vm.item, logoSaved);
    }

    function openPackageContentDayTranslations() {
      PackageContentDayService.openPackageContentDayTranslations(
        vm.item,
        vm.packageContent.id,
        vm.additionalLanguages
      );
    }

    function onPackageContentDayPhotosSaved(photos) {
      vm.item.photos = photos;
      vm.originalItem = angular.copy(vm.item); // store server data

      vm.onPackageContentDaySaved({ item: vm.item });
    }
  }
})();
